export default "__VITE_ASSET__Cexznb0$__"